import { RobotOutlined } from "@ant-design/icons";
import { AutoComplete, Button, Col, Form, Input, Row, Select, Space, Tooltip, message } from "antd";
import classifiers from "common/data/classifiers";
import { descriptionRules, nameRules } from "common/FormValidationRules";
import { AIGenerateTagButton, DataTagPreview, DataTagPreviewOverlay } from "components";
import AIDescriptionGenerator from "components/molecules/AIDescriptionGenerator";
import React, { Component } from "react";
import CypressTestIds from "../../../cypress/CypressTestIds";

const { Option } = Select;

class ManageDataTag extends Component {
    constructor(props) {
        super(props);
        this.dataTagDefault = {
            backgroundColor: null,
        };
        this.formRef = React.createRef();
        this.state = {
            readOnlyView: this.props.action === "view",
            previewVisible: false,
            isEditMode: this.props.action === "edit",
            currentColor: this.props.dataTag?.backgroundColor || null,
            aiDescriptionModalVisible: false,
            businessAreaName: "",
            tagNameForDescription: "",
        };
        this.emptyObject = {};
    }

    componentWillMount() {}

    componentDidMount() {
        if (this.props.dataTag) {
            this.formRef.current.setFieldsValue({ ...this.props.dataTag, backgroundColor: this.props.dataTag?.backgroundColor || this.dataTagDefault.backgroundColor });
        } else {
            this.selectDefaultBusinessArea();
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.businessAreaList !== prevProps.businessAreaList && this.props.businessAreaList.length > 0) {
            this.selectDefaultBusinessArea();
        }
        if (this.props.activeBusinessAreaId !== prevProps.activeBusinessAreaId && this.props.activeBusinessAreaId && this.props.action === "create") {
            this.selectDefaultBusinessArea(true);
        }
    }

    selectDefaultBusinessArea = (forceUpdate = false) => {
        if (this.props.businessAreaList.length > 0) {
            if (this.formRef.current) {
                let selectedBusinessAreaId = this.formRef.current.getFieldValue(["businessAreaId"]);
                if (!selectedBusinessAreaId || forceUpdate) {
                    this.formRef.current.setFieldsValue({
                        businessAreaId: this.props.activeBusinessAreaId || this.props.businessAreaList[0].businessAreaId,
                        backgroundColor: this.dataTagDefault.backgroundColor,
                    });
                }
            }
        }
    };

    onFormSubmit = (formData) => {
        if (!this.isSaveAllowed()) {
            return;
        }
        if (this.props.action === "edit") {
            this.props.updateDataTag(this.props.dataTag, { ...formData });
        } else {
            let dataTag = { ...this.dataTagDefault, ...formData };
            this.props.createDataTag(dataTag);
        }
    };

    togglePreview = () => {
        this.setState((prevState) => ({
            previewVisible: !prevState.previewVisible,
        }));
    };

    getFormErrors = (fieldName) => {
        if (this.props.formErrors && this.props.formErrors[fieldName]) {
            return {
                help: this.props.formErrors[fieldName],
                validateStatus: "error",
            };
        }
        return this.emptyObject;
    };

    isReadOnlyView = () => {
        return this.state.readOnlyView || !(this.props.permission.canEdit || this.props.permission.canAdd);
    };

    isSaveAllowed = () => {
        if (this.props.action === "edit") {
            return this.props.permission.canEdit;
        } else if (this.props.action === "create") {
            return this.props.permission.canAdd;
        }
        return false;
    };

    // onColorChange = (color) => {
    //     const hexColor = color ? color.toHexString() : null
    //     this.setState({ currentColor: hexColor })
    //     this.formRef.current.setFieldsValue({ backgroundColor: hexColor })
    //     }

    // clearColor = () => {
    //     this.setState({ currentColor: null })
    //     this.formRef.current.setFieldsValue({ backgroundColor: null })
    //     }

    onFieldsChange = (_, allFields) => {
        if (this.formRef.current) {
            let uploadFile = this.formRef.current.getFieldValue(["uploadFile"]);
            if (uploadFile) {
                this.setState({
                    uploadFileExist: true,
                });
            }
        }

        const tagNameField = _.find((field) => field.name && field.name[0] === "tagName");

        if (tagNameField) {
            // Update state to trigger button re-render naturally
            this.setState({
                tagNameForDescription: tagNameField.value || "",
            });
        }
    };

    getCurrentFormValues = () => {
        if (!this.formRef.current) return {};

        const values = this.formRef.current.getFieldsValue();
        const selectedBusinessArea = this.props.businessAreaList.find((ba) => ba.businessAreaId === values.businessAreaId);

        return {
            tagName: values.tagName || "",
            businessAreaName: selectedBusinessArea?.name || "",
            tagDescription: values.tagDescription || "",
            // backgroundColor: values.backgroundColor || null
        };
    };

    openAIDescriptionModal = () => {
        const tagName = this.formRef.current?.getFieldValue(["tagName"]);
        const businessAreaId = this.formRef.current?.getFieldValue(["businessAreaId"]);
        const businessArea = this.props.businessAreaList.find((ba) => ba.businessAreaId === businessAreaId);

        if (!tagName || !tagName.trim()) {
            const tagNameInput = this.formRef.current?.getFieldInstance(["tagName"]);
            if (tagNameInput) {
                tagNameInput.focus();
            }
            return;
        }

        this.setState({
            aiDescriptionModalVisible: true,
            tagNameForDescription: tagName.trim(),
            businessAreaName: businessArea?.name || "",
        });
    };

    closeAIDescriptionModal = () => {
        this.setState({
            aiDescriptionModalVisible: false,
        });
    };

    selectAIDescription = (description) => {
        if (!description || !description.trim()) {
            message.error("Please select a valid description");
            return;
        }
        if (this.formRef.current) {
            try {
                this.formRef.current.setFieldsValue({ tagDescription: description.trim() });
                message.success("Description set successfully");
            } catch (error) {
                message.error("Failed to set description. Please try again.");
            }
        }
        this.closeAIDescriptionModal();
    };

    isAIDescriptionButtonEnabled = () => {
        const tagName = this.formRef.current?.getFieldValue(["tagName"]);
        return tagName && tagName.trim().length > 0 && this.props.openAIKeyExists && !this.isReadOnlyView();
    };

    render() {
        let businessAreaOptions = this.props.businessAreaList.map((businessArea) => ({ id: businessArea.businessAreaId, name: businessArea.name }));
        let dataTags = classifiers.map((classifier) => ({ value: classifier.name }));
        // const presetColors = [
        //     {
        //         label: "Recommended Colors",
        //         colors: [
        //         "#e6f4ff", // Light Blue
        //         "#f6ffed", // Light Green
        //         "#fff7e6", // Light Orange
        //         "#fff1f0", // Light Red
        //         "#f9f0ff", // Light Purple
        //         "#f0f5ff", // Light Indigo
        //         ],
        //     },
        //     {
        //         label: "System Colors",
        //         colors: [
        //         "#f5f5f5", // Light Gray
        //         "#fafafa", // Lighter Gray
        //         "#f0f2f5", // Background Gray
        //         ],
        //     },
        // ]
        return (
            <>
                <Form
                    labelCol={{ span: 3 }}
                    layout="horizontal"
                    labelAlign="left"
                    ref={this.formRef}
                    name="basic"
                    onFinish={this.onFormSubmit}
                    initialValues={this.dataTagDefault}
                    onFieldsChange={this.onFieldsChange}
                    onValuesChange={this.props.onValuesChanged}
                >
                    <Row gutter={[16, 8]}>
                        <Col span={24} style={{ textAlign: "left" }}>
                            <Form.Item
                                className="wrap-label"
                                {...this.getFormErrors("businessAreaId")}
                                label="Business Area"
                                name={["businessAreaId"]}
                                rules={[{ required: true, message: "Please select a business area" }]}
                            >
                                <Select
                                    placeholder="Select a business area"
                                    allowClear
                                    {...(() => (this.isReadOnlyView() ? { open: false } : {}))()}
                                    data-testid={CypressTestIds.DATATAGS_DATATAG_BUSINESSAREA_SELECT}
                                >
                                    {businessAreaOptions.map((item) => (
                                        <Option key={item.id || Date.now()} value={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={[16, 8]}>
                        <Col span={24} style={{ textAlign: "left" }}>
                            <Form.Item
                                className="wrap-label"
                                {...this.getFormErrors("tagName")}
                                label="Tag Name"
                                name={["tagName"]}
                                validateFirst={true}
                                rules={[...nameRules, { max: 50, message: "Tag name must not exceed 50 characters" }]}
                                data-testid={CypressTestIds.DATATAGS_DATATAG_NAME_INPUT}
                            >
                                <AutoComplete
                                    disabled={this.isReadOnlyView()}
                                    options={dataTags}
                                    showSearch={{
                                        filterOption: (inputValue, option) => option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1,
                                    }}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                    {/* <Row gutter={[16, 8]}>
            <Col span={24} style={{ textAlign: "left" }}>
              <Form.Item label="Tag Color" name={["backgroundColor"]} className="wrap-label">
                <Space>
                  <ColorPicker
                    disabled={this.isReadOnlyView()}
                    placement="top"
                    value={this.state.currentColor}
                    onChange={this.onColorChange}
                    presets={presetColors}
                  />
                  {this.state.currentColor && (
                    <Tag className="cursor-pointer" onClick={this.clearColor}>
                      Clear Color
                    </Tag>  
                  )}
                </Space>
              </Form.Item>
            </Col>
          </Row> */}
                    <Row gutter={[16, 8]}>
                        <Col span={24} style={{ textAlign: "left" }}>
                            <div className="relative">
                                <Form.Item
                                    {...this.getFormErrors("tagDescription")}
                                    label="Tag Description"
                                    name={["tagDescription"]}
                                    rules={descriptionRules}
                                    data-testid={CypressTestIds.DATATAGS_DATATAG_DESCRIPTION_INPUT}
                                >
                                    <Input.TextArea
                                        disabled={this.isReadOnlyView()}
                                        maxLength={500}
                                        showCount
                                        autoSize={{ minRows: 3, maxRows: 6 }}
                                        placeholder={this.props.action === "create" ? "Enter tag description or use AI to generate suggestions..." : "No description available"}
                                        // style={{ paddingTop: '32px' }}
                                    />
                                </Form.Item>
                                {this.props.openAIKeyExists && !this.isReadOnlyView() && (
                                    <Tooltip title={!this.isAIDescriptionButtonEnabled() ? "Enter a tag name first" : "Generate AI description suggestions"} placement="left">
                                        <Button
                                            type="text"
                                            size="small"
                                            icon={<RobotOutlined />}
                                            onClick={this.openAIDescriptionModal}
                                            disabled={!this.isAIDescriptionButtonEnabled()}
                                            data-testid={CypressTestIds.DATATAGS_DATATAG_AI_DESCRIPTION_BUTTON}
                                            className={`absolute right-1 top-1 z-10 flex h-8 w-8 items-center justify-center rounded-md border-0 ${
                                                this.isAIDescriptionButtonEnabled()
                                                    ? "border border-gray-200 bg-white text-blue-500 shadow-sm hover:bg-blue-50 hover:text-blue-600"
                                                    : "bg-gray-50 text-gray-400"
                                            }`}
                                            style={{
                                                position: "absolute",
                                                top: "4px",
                                                right: "4px",
                                                zIndex: 10,
                                                minWidth: "32px",
                                                height: "24px",
                                                padding: "0",
                                                fontSize: "12px",
                                                background: this.isAIDescriptionButtonEnabled() ? "linear-gradient(135deg, #667eea 0%, #764ba2 100%)" : "#f5f5f5",
                                                color: this.isAIDescriptionButtonEnabled() ? "white" : "#999",
                                                border: "none",
                                                boxShadow: this.isAIDescriptionButtonEnabled() ? "0 2px 4px rgba(102, 126, 234, 0.3)" : "none",
                                            }}
                                        />
                                    </Tooltip>
                                )}
                            </div>
                        </Col>
                    </Row>
                    <Row gutter={[16, 16]} align="middle">
                        <Col span={12} style={{ textAlign: "left" }}>
                            {this.props.action === "create" && !this.isReadOnlyView() && (
                                <AIGenerateTagButton
                                    generateTagsWithAI={this.props.generateTagsWithAI}
                                    createTags={this.props.createTags}
                                    isGeneratingTags={this.props.isGeneratingTags}
                                    isCreatingTags={this.props.isCreatingTags}
                                    businessAreaList={this.props.businessAreaList}
                                    aiGeneratedTags={this.props.aiGeneratedTags}
                                    resetAiGeneratedTags={this.props.resetGeneratedTags}
                                    bulkCreateErrors={this.props.bulkCreateErrors}
                                    aiGeneratedErrors={this.props.aiGeneratedErrors}
                                    openAIKeyExists={this.props.openAIKeyExists}
                                    rephraseWithAI={this.props.rephraseDataTag}
                                    isRephrasing={this.props.isRephrasingTags}
                                    rephrasedDataTag={this.props.rephrasedDataTag}
                                />
                            )}
                        </Col>
                        <Col span={12} style={{ textAlign: "right" }}>
                            <Space>
                                <Button onClick={this.props.onCancel} data-testid={CypressTestIds.DATATAGS_DATATAG_CANCEL_BUTTON}>
                                    Cancel
                                </Button>
                                <Button
                                    type="primary"
                                    htmlType="submit"
                                    disabled={this.isReadOnlyView() || !this.isSaveAllowed()}
                                    data-testid={CypressTestIds.DATATAGS_DATATAG_SAVE_BUTTON}
                                >
                                    {this.state.uploadFileExist ? "Save and upload" : "Save"}
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </Form>
                <AIDescriptionGenerator
                    visible={this.state.aiDescriptionModalVisible}
                    onClose={this.closeAIDescriptionModal}
                    onSelect={this.selectAIDescription}
                    tagName={this.state.tagNameForDescription}
                    businessAreaName={this.state.businessAreaName}
                    generateDescriptionWithAI={this.props.generateDescriptionWithAI}
                    aiDescription={this.props.aiDescription}
                />
                {this.state.isEditMode && (
                    <DataTagPreviewOverlay isVisible={this.state.previewVisible} onToggle={this.togglePreview}>
                        <DataTagPreview {...this.getCurrentFormValues()} />
                    </DataTagPreviewOverlay>
                )}
            </>
        );
    }
}

export default ManageDataTag;
